module.exports = __webpack_public_path__ + "img/rotate_left.47177242.svg";